module.exports = __webpack_public_path__ + "static/LivingCity-bc045b327172c9879385e228ddea2a7a.png";